import Main from './Main'
import Lista from './components/EstadoLote'
import Novo from './components/NovoEstadoLote'

export default [
  {
    path: 'estado-lote',
    name: 'config.estado.lote',
    component: Main,
    redirect: { name: 'config.estado.lote.list' },
    children: [
      {
        path: '/',
        name: 'config.estado.lote.list',
        component: Lista
      },
      {
        path: 'registro',
        name: 'config.estado.lote.novo',
        component: Novo
      },
      {
        path: ':id',
        name: 'config.estado.lote.edit',
        component: Novo
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/app/configuracoes/estado-lote/routes.js